import {Injectable} from "@angular/core";
import {DepotActions} from "../actions/depot.actions";
import {ActivatedRoute, Params} from "@angular/router";
import {StockActions} from "./store-management/stock/stock.actions";

@Injectable()
export class ReduxRouteService {

  constructor(private depotActions: DepotActions,
              private stockActions: StockActions) {


  }

  public processRoute(route: ActivatedRoute): void {
    route.params.subscribe((params: Params) => {

      if (params['l_id']) {
        let depotId = params['l_id'];
        this.depotActions.selectDepot(depotId);
        console.info('Set depot parameter: ' + depotId);
      }

      if (params['b_id']) {
        let stockId = params['b_id'];
        this.stockActions.selectStock(stockId);
        console.info('Set stock parameter: ' + stockId);
      }

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/redux-route.service.ts